import {AtomSchemaType, NavigationListAtomOptionsType} from "@geenee/shared/type/atom.type";

export const getPropsFromOwner = (
  atoms: AtomSchemaType<NavigationListAtomOptionsType>[],
  extendProps: Object = {}
) => ({
  atoms: atoms.map((a) => a),
  ...extendProps
});
